/**
 * Top-level module base paths. Combine with entries from `EndPoint` to form full routes.
 */
export const Module = {
  consumer: "/consumer",
} as const;

/**
 * REST endpoints used throughout the consumer application.
 * Keep this map alphabetised inside logical groupings to simplify lookups.
 */
export const EndPoint = {
  SIGNIN: "/signin",
  SIGNUP: "/signup",
  WALLET: "/wallet",
  SUPPORT: "/support",
  POST_TOKEN: "/token",
  VERIFY_EMAIL: "/email-status",
  CHECK_STATUS: "/check-status",

  /** Profile */
  USER_PROFILE: "/profile",
  USER_LOGOUT: "/logout",

  /** Static Content */
  CONTENT: "/content",
  FAQ_CONTENT: "/content-faq",
  CMS_LINKS: "/cms-content",

  /** Announcements */
  ANNOUNCEMENTS: "/announcements",
  ANNOUNCEMENT_COUNT: "/announcements/alert",
  ANNOUNCEMENT_FILTER_LIST: "/announcements/filter",

  /** User Support */
  USER_SUPPORT: "/support-choice",
  MANUFACTURER_LIST: "/manufacture-list",

  /** Product Details */
  PRODUCT_DETAILS: "/scan-product/product-details",
  CLAIM_NFT: "/scan-product/product-details/verify/claim-nft",
  VERIFY_SCRATCHOFF_CODE: "/scan-product/product-details/verify",
  VALIDATE_SERIAL_NUMBER: "/scan-product/validate-serial-number",
  CLAIM_NFT_DATA: "/scan-product/product-details/verify/claim-nft-data",

  /** Blockchain Product Chain */
  PRODUCT_CHAIN: "/blockchain-view/product-details",
  PRODUCT_COA_CHAIN: "/blockchain-view/product-coa-details",

  /** Notification Preferences */
  NOTIFICATION_PREFERENCES: "/notification-preferences",

  /** My Library */
  MY_LIBRARY: "/library",
  PRODUCT_FILTER_STRAIN_LISTING: "/library/filter/strains",
  PRODUCT_FILTER_MANUFACTURER_LISTING: "/library/filter/manufacturer",
  PRODUCT_FILTER_PRODUCTTYPE_LISTING: "/library/filter/product-types",

  /** Strain Details */
  STRAIN_DETAILS: "/library/strain-details",
  STRAIN_RECENT_BATCHES: "/library/strain-details/recent-batches",

  /** Manufacturer Details */
  MANUFACTURER_BATCH_DETAILS: "/products/manufacturer/batches",
  MANUFACTURER_DETAILS: "/product-details/manufacturer-details",
  MANUFACTURER_RECENT_BATCHES: "/library/manufacturer-details/recent-batches",
  MANUFACTURER_STRAINS_LISTING: "/product-details/manufacturer-details/strains",

  /** Compound Listing */
  COMPOUNDS_LIST: "/compounds",
  COMPOUND_LISTING: "/product-details/compounds",

  /** Common */
  CREATE_ZENDESK_TICKET: "/zendask/create-ticket",

  /** Review */
  REVIEW: "/product/review-rating",

  VERIFY_USERNAME: "/verify-username",

  /** Ribbon and Rewards */
  UNEARNED_RIBBON_DETAILS: "/rewards/ribbons",
  EARNED_RIBBONS_LISTING: "/rewards/earned-ribbons",
  UNEARNED_RIBBONS_LISTING: "/rewards/unearned-ribbons",

  /** Badges */
  BADGES: "/badges",

  /** Brand Directory */
  BRAND_DIRECTORY: "/brand-directory",
  BRAND_DIRECTORY_FILTER_STATES: "/brand-directory/filter/states",
} as const;
